<template>
  <div class="module-container">
    <component
      :is="shortcutOrExpandable"
      :module="module"
      :event-bus="eventBus"
    />
  </div>
</template>

<script>
import menuComponent from '@/components/layout/navigation/menu/mixins/menuComponent';
import MenuModuleExpandable from '@/components/layout/navigation/menu/level2/MenuModuleExpandable.vue';
import MenuModuleShortcut from '@/components/layout/navigation/menu/level2/MenuModuleShortcut.vue';
import mitt from 'mitt';

export default {
  name: 'MenuModule',
  components: { MenuModuleShortcut, MenuModuleExpandable },
  mixins: [menuComponent],
  props: {
    module: {
      type: Object,
      default: () => {},
    },
    eventBus: {
      type: Object,
      default: () => mitt(),
    },
  },
  computed: {
    isShortcut() {
      return this.module.shortcutModuleKey;
    },
    shortcutOrExpandable() {
      return this.isShortcut
        ? 'MenuModuleShortcut'
        : 'MenuModuleExpandable';
    },
  },
};
</script>
